module.exports = __webpack_public_path__ + "assets/img/lasz2.64502a8d.png";